import Preview from './Preview';
import {useState, useEffect} from 'react';
import * as StyleFunctions from './utilities/StyleFunctions';
import * as CoreFns from './utilities/CoreFns';
import WagmiWrap from './WagmiWrap';


function App(props) {

  var currentList = props.currentList;

  var overallWidth = props.overallWidth;
  var width = props.width;
  var height = props.height;
  var overlays = props.overlays;
  var programSetID = props.programSetID;
  var ownVariables = props.ownVariables;
  var setOwnVariables = props.setOwnVariables;
  var isReal = props.isReal;
  var run = props.run;
  var urlParamsForExecution = props.urlParamsForExecution;
  var offsetLeft = props.offsetLeft;
  var offsetTop = props.offsetTop;
  var chains = props.chains;
  var urlHeader = props.urlHeader;

  const [musicStatus, setMusicStatus] = useState({});

  const [programSetIDDisp, setProgramSetIDDisp] = useState(programSetID);
  const [sCurrentList, setSCurrentList] = useState(false);
  const [appInfo, setAppInfoR] = useState(false);

  function setAppInfo(newAppInfo){
    if (newAppInfo){
      var newP = {};
      var ff = Object.keys(newAppInfo);
      ff.forEach((aP, index)=>{
        newP[aP] = newAppInfo[aP];
      })
      setAppInfoR(newP);      
    }else{
      setAppInfoR(false);
    }
  }

  useEffect(()=>{
    StyleFunctions.doStartSim(currentList, setAppInfo, setOwnVariables, setMusicStatus, width, height, urlParamsForExecution, urlHeader, chains);
    var currentListUsed = cleanSet(currentList);
    setSCurrentList(currentListUsed);    
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    StyleFunctions.doStartSim(currentList, setAppInfo, setOwnVariables, setMusicStatus, width, height, urlParamsForExecution, urlHeader, chains);
    var currentListUsed = cleanSet(currentList);
    setSCurrentList(currentListUsed);
    setProgramSetIDDisp(programSetID);
  }, [programSetID]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!appInfo){
    return <div>Simualated Screen Reload...</div>
  }else if (programSetID !== programSetIDDisp){
    return <div style={{width}}></div>
  }
//

  var inside = <Preview chains={chains} currentList={sCurrentList} setAppInfo={setAppInfo} overallWidth={overallWidth} width={width} height={height} appInfo={appInfo} overlays={overlays} programSetID={programSetID} ownVariables={ownVariables} setOwnVariables={setOwnVariables} musicStatus={musicStatus} setMusicStatus={setMusicStatus} run={run}  offsetTop={offsetTop} offsetLeft={offsetLeft} urlHeader={urlHeader}/>

  var currencyID = CoreFns.getChainDAppIsOn(sCurrentList);

  return <WagmiWrap inside={inside} chains={chains} currencyID={currencyID} />
}

function cleanSet(currentList){
    var js = JSON.parse(JSON.stringify(currentList));
    return js;
}



export default App;
